var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{attrs:{"fixed":"","hover":"","bordered":"","small":"","items":_vm.items,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell(level)",fn:function(row){return [_vm._v(" "+_vm._s(row.item.level)+": "+_vm._s(row.item.name)+" ")]}},{key:"cell(color)",fn:function(row){return [_c('div',{staticClass:"cognitive-level-color",style:({
          'background-color': row.item.color,
          color: row.item.color,
        })})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }